import React from "react";
import { toast } from "react-toastify";
import { Offcanvas } from "react-bootstrap";
import { getUsers } from "store/users";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Joi from "joi-browser";
import _ from "lodash";

//  Images
import closeIcon from "include/images/dark-close-icon.svg";

//  Components
import Form from "common/form/form";
import NextButton from "common/form/submitButton";
import AlertSuccess from "common/alert/alertSuccess";
import AlertError from "common/alert/alertError";
import { loadBGGames, updateBGGame } from "store/games";
class updateValidateGameData extends Form {
  state = {
    loading: false,
    data: {
      validateGameData: "",
    },
    errors: {},
    imageChange: false,
    loadingImages: false,
    loadingReward: false,
    showTooltip: false,
    showFields: false,
    showNFTFields: false,
    loadingNFT: false,
    ethVPrice: "",
    loadingEth: false,
  };
  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.showModal !== prevProps.showModal) {
      this.clearData();
    }
    if (this.props.showModal && this.props.showModal !== prevProps.showModal) {
      const game = this.props.game;
      this.setState({
        data: {
          ...this.state.data,
          validateGameData: game.validateGameData,
        },
      });
    }
  };
  doSubmit = (e) => {
    this.setState({ loadingReward: true });
    const data = { ...this.state.data };
    const errors = { ...this.state.errors };

    const payLoad = {
      validateGameData: data.validateGameData,
    };
    const game = this.props.game;
    this.props.updateBGGame(payLoad, game.id, (gameRes) => {
      this.setState({ loadingBGGame: false });
      if (gameRes.status === 200) {
        this.props.loadBGGames({}, null);
        toast(<AlertSuccess message="Information Saved" />, {
          containerId: 1,
        });
        setTimeout(() => {
          this.props.toggleModal();
        }, 1000);
      } else {
        toast(<AlertError message={gameRes.data && gameRes.data.message} />, {
          containerId: 1,
        });
      }
    });
  };

  onChange = (e) => {
    console.log(e);
    const data = { ...this.state.data };
    const errors = { ...this.state.errors };
    data[e.target.name] = e.target.value;

    this.setState({ data, errors });
  };
  schema = {
    validateGameData: Joi.string().allow(""),
  };
  clearData = () => {
    this.setState({
      loading: false,
      data: {
        validateGameData: "",
      },
      errors: {},
      loadingImages: false,
      loadingReward: false,
      showTooltip: false,
      showFields: false,
      showNFTFields: false,
      loadingNFT: false,
      ethVPrice: "",
    });
  };
  render() {
    return (
      <Offcanvas
        className={"offcanvas offcanvas-end custom-offcanvas-pannel"}
        show={this.props.showModal}
        onHide={this.props.toggleModal}
        id="rewardPannel"
        placement="right"
        name="rewardPannel"
        backdrop={true}
      >
        <Offcanvas.Header>
          <h5>Update Validate Game Function</h5>
          <div
            className="btn_close pointer"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={this.props.toggleModal}
          >
            <img src={closeIcon} alt="" />
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="new-form-group">
            <textarea
              style={{ height: "660px" }}
              rows="40"
              name="validateGameData"
              id="validateGameData"
              className={this.state.errors.validateGameData ? "form-control error" : "form-control"}
              multiline
              value={this.state.data.validateGameData}
              onChange={this.onChange}
            />
          </div>
        </Offcanvas.Body>
        <div className="offcanvas-footer">
          <NextButton
            classData="btn btn-default btn-block h-100"
            label="Save"
            loading={this.state.loadingReward || this.state.loadingImages}
            handleSubmit={this.handleSubmit}
          />
        </div>
      </Offcanvas>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadBGGames: (params, callback) => dispatch(loadBGGames(params, callback)),
  updateBGGame: (data, id, callback) => dispatch(updateBGGame(data, id, callback)),
});
const mapStateToProps = (state) => ({
  getUsers: getUsers(state),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(updateValidateGameData));
